import React from 'react'
import { Grid } from '@material-ui/core'
import { LanguagePicker, ProfileButton, FAQButton } from '../Atoms'


const ButtonCollection = () => (
    <Grid container
        justifyContent="space-between"
        alignItems="center"
        style={{ width: 150 }}
    >
        <FAQButton />
        <LanguagePicker />
        <ProfileButton />
    </Grid>
)

export default ButtonCollection